// servizio per il recupero delle info per il popolamento delle pagine

import axios from 'axios'
import { bus } from '../main'

export const dataService = {
    getUserRole,
    getUserInfo,
    getEnterpriseInfo,
    getStudentsList,
    getStudentsSettore,
    getInstituteInfo,
    getEnterprisesList,
    getUsersList,
    getTutorAzienda,
    getAssignmentList,
    getJobOffersList,
    getStatiList,
    getComuniList,
    getAtecoList,
    getIstatList,
    getDocAutorizzazioneInfo,
    getDocNominaRespInfo,
    getCollaborationInstitutes,
    getEnterpriseDoc,
    getStudentDoc,
    getListaIndirizziStudio,
    getRichiesteAlternanza,
    getEmailFromIdDoc,
    getRespDoc,
    getArticolazioni,
    getArticolazioniSettore,
    getInformazioniAlternanza,
    getAssegnazioneIndirizzoStudio,
    getAssegnazioneArticolazione,
    getTutorSettore,
    getStudentsTutor,
    getIndirizziStudioTutorArticolazione,
    getRichiesteAlternanzaIndirizzoStudio,
    getAllieviPreAssegnati,
    getAllieviAssegnatiAzienda,
    getAreeIstituto,
    getAllieviArea,
    getAziendeArea,
    getColloquiAzienda,
    getColloquiIstituto,
    getAllieviColloquiCV,
    getAziendeColloquiCV,
    getRichiesteTirEstivi,
    getAllieviAssegnatiAziendaTirEstivo,
    getAllieviPreAssegnatiTirEstivi,
    getStudentsTutorTirEstivi,
    getRichiesteTirEstiviIndirizzoStudio,
    getTirEstiviIstituto,
    getEnterpriseTutors,
    getTutorFormativi,
    getAssociazioniTutorFormativoTirEstivi,
    getClassiIstitutoAnno,
    getConvenzioneAttivita,
    getProgettoOrientamento,
    getRichiesteTirEstiviAllievo,
    getAllieviAssegnatiAziendaTirFormativo,
    getRichiesteTirFormativi,
    getStudentsTutorTirFormativi,
    getRichiesteTirFormativiIndirizzoStudio,
    getTirFormativiIstituto,
    getAllieviPreAssegnatiTirFormativi,
    getAssociazioniTutorFormativoTirFormativi,
    getAssociazioniTutorAziendaleTirEstivo,
    getReportVisite,
    getReportVisiteAdmin,
    getConsensoAttivita,
    getCurriculumVitae,
    getCurriculumAnni,
    getCurriculumArticolazioni,
    getCurriculumClassi,
    getCurriculumAllievi,
    getRichiesteTirFormativiAllievo,
    getDetailsAbbinamentoAllievoAzienda,
    getDetailsAbbinamentoTutorAllievo,
    getAssociazioniTutorAziendaleTirFormativo,
    getAttestatoFinaleInfo,
    getDomandeQuestionario,
    checkQuestionario,
    getRisposteQuestionario,
    getListaAttivitaIstituto,
    getListaTipiAttivita,
    getConvenzioneAttivitaFromId,
    getPercorsoFormativo,
    getPattoFormativo,
    getAssociazioniTutorAziendaleAlternanza,
    getRichiesteAlternanzaAllievo,
    getAssociazioniTutorFormativoAlternanza,
    getAnniScolastici,
    getStoricoSoggetto,
    getLastYearSubscription,
    getRichiesteAttivita,
    getStudentsTutorTirReIns,
    getAllieviPreAssegnatiTirReIns,
    getAllieviAssegnatiAziendaTirReIns,
    getRichiesteTirReInsAllievo,
    getPreferenzeWorkshopAzienda,
    getListaIscrizioniWorkshop,
    getTipiContratto,
    getListaProposteLavoroAzienda,
    getListaProposteLavoroIstituto,
    getListaProposteLavoroAllievo,
    getQuestionariWorkshopAziende,
    getQuestionariWorkshopAllievi,
    getTemplateDoc,
    getCandidaturePropostaLavoro,
    getGiorniWorkshop,
    getTurniWorkshop,
    getAllieviAssegnatiTutor,
    getClassiArticolazioneIstitutoAnno,
    getContattiAzienda,
    getNoteAzienda,
    getPreferenzeColloquioAzienda,
    checkPattoCorresponsabilitaAllievo,
    getAllieviIscrittiTipoAttivita,
    getAssegnazioniAreeAziende,
    getAssegnazioniAreeAllievi,
    getAssegnazioniAllieviAttivitaSettore,
    getGiorniColloquiAzienda,
    getTurniColloquiCV,
    getElencoFirme,
    getIspezioneAzienda,
    getIspezione,
    getConvenzioneDigitale,
    getPercorsoFormativoDigitale,
    getDocDigitaleById,
    getAttivitaFromIscrizioneAzienda,
    getDocDVR,
    createAbbinamentoAlternanza,
    downloadAttivitaReport,
    downloadRendicontazionePCTOReport,
    getApprendistati,
    getTest
}

// const headUrl = "http://localhost:8181/RestApi/valtis/valtis"

const headUrl = "https://valtis.infosys.it/RestApi/valtis/valtis"


function getUserRole(username: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/UserRole", {
        params: {
            username: username
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(resp => {
        return resp.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error;
        })
}

function getUserInfo(idUtente: number, idTipoSoggetto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return getLastYearSubscription(idUtente).then(result => {
        var idAnnoScolastico = result.IdAnnoScolastico
        return axios.get(headUrl + "/UserInfo", {
            params: {
                idUtente: idUtente,
                idTipoSoggetto: idTipoSoggetto,
                idAnnoScolastico: idAnnoScolastico
            },
            headers: {
                Authorization: 'Bearer ' + token
            }
        })
            .catch(error => {
                bus.$emit('errorOperation', error.response.statusText);
                throw error;
            })
    })

}

function getEnterpriseInfo(idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/EnterpriseInfo", {
        params: {
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error;
        })
}

function getInstituteInfo(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/InstituteInfo", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error;
        })
}

function getStudentsList(idIstituto: number, idAnnoScolastico: number, annoCorso?: string, isDiplomato?: boolean) {
    //ritorna la lista degli studenti per un dato istituto
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/StudentsList", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            annoCorso: annoCorso,
            isDiplomato: isDiplomato
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getStudentsSettore(idIstituto: number, idAnnoScolastico: number, idSettore: number) {
    //ritorna la lista degli studenti per un dato istituto
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/StudentsSettore", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idSettore: idSettore
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getEnterprisesList(idIstituto: number) {
    //ritorna la lista delle aziende
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/EnterprisesList", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getUsersList(idSoggetto: number, idTipoSoggetto: number) {
    //ritorna la lista degli utenti di un soggetto
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/UsersList", {
        params: {
            idSoggetto: idSoggetto,
            idTipoSoggetto: idTipoSoggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssignmentList(idSoggetto: number) {
    //ritorna l'elenco delle assegnazioni per tipologia
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AssignmentsList", {
        params: {
            idSoggetto: idSoggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getJobOffersList(idSoggetto: number, idTipoSoggetto: number) {
    //ritorna l'elenco delle offerte di lavoro
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/JobOffersList", {
        params: {
            idSoggetto: idSoggetto,
            idTipoSoggetto: idTipoSoggetto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })

}

function getStatiList() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/states", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getComuniList() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/idCaps", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAtecoList() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ateco", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error
    })
}

function getIstatList() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/istat", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error
    })
}

function getDocAutorizzazioneInfo(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetDocAutorizzazione", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error
    })
}

function getDocNominaRespInfo(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetDocResponsabile", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getCollaborationInstitutes(idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetCollaborationInstitutes", {
        params: {
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getEnterpriseDoc(idAzienda: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetEnterpriseDoc", {
        params: {
            idAzienda: idAzienda,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getStudentDoc(idStudente: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetStudentDoc", {
        params: {
            idStudente: idStudente,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getListaIndirizziStudio(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetIndirizziStudio", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getRichiesteAlternanza(idIscrizioneAttivita: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteAlternanza", {
        params: {
            idIscrizioneAttivita: idIscrizioneAttivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getEmailFromIdDoc(docType: string, idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetEmailFromIdDoc", {
        params: {
            docType: docType,
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getRespDoc(idAzienda: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRespDoc", {
        params: {
            idAzienda: idAzienda,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getArticolazioni(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetArticolazioni", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getArticolazioniSettore(idIstituto: number, idSettore: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetArticolazioniSettore", {
        params: {
            idIstituto: idIstituto,
            idSettore: idSettore
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getInformazioniAlternanza(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetInformazioniAlternanza", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getAssegnazioneIndirizzoStudio(idUtente: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetAssociazioneIndirizzoStudio", {
        params: {
            idUtente: idUtente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getAssegnazioneArticolazione(idUtente: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetAssociazioneArticolazione", {
        params: {
            idUtente: idUtente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getTutorSettore(idIstituto: number, idSettore: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetTutorSettore", {
        params: {
            idIstituto: idIstituto,
            idSettore: idSettore
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getStudentsTutor(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/StudentsTutor", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getIndirizziStudioTutorArticolazione(idUtente: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetIndirizzoStudioFromArticolazione", {
        params: {
            idUtente: idUtente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteAlternanzaIndirizzoStudio(idIndirizzoStudio: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteAlternanzaIndirizzoStudio", {
        params: {
            idIndirizzoStudio: idIndirizzoStudio,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviPreAssegnati(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviPreAssegnati", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviAssegnatiAzienda(idAnnoScolastico: number, idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiAzienda", {
        params: {
            idAnnoScolastico: idAnnoScolastico,
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getTutorAzienda(idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/TutorAzienda", {
        params: {
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAreeIstituto(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AreeIstituto", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}
function getAllieviArea(idArea: number, idArticolazione: string, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviArea", {
        params: {
            idArea: idArea,
            idArticolazione: idArticolazione,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}
function getAziendeArea(idArea: number, idArticolazione: string, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AziendeArea", {
        params: {
            idArea: idArea,
            idArticolazione: idArticolazione,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getColloquiAzienda(idAnnoScolastico: number, idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ColloquiAzienda", {
        params: {
            idAnnoScolastico: idAnnoScolastico,
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getColloquiIstituto(idArticolazione: string, idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ColloquiIstituto", {
        params: {
            idArticolazione: idArticolazione,
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviColloquiCV(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviColloquiCV", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAziendeColloquiCV(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AziendeColloquiCV", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirEstivi(idIscrizioneAttivita: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirEstivi", {
        params: {
            idIscrizioneAttivita: idIscrizioneAttivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getAllieviAssegnatiAziendaTirEstivo(idAnnoScolastico: number, idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiAziendaTirEstivo", {
        params: {
            idAnnoScolastico: idAnnoScolastico,
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviPreAssegnatiTirEstivi(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviPreAssegnatiTirEstivi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getStudentsTutorTirEstivi(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/StudentsTutorTirEstivi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirEstiviIndirizzoStudio(idIndirizzoStudio: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirEstiviIndirizzoStudio", {
        params: {
            idIndirizzoStudio: idIndirizzoStudio,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getTirEstiviIstituto(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetTirEstiviIstituto", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getEnterpriseTutors(idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/EnterpriseTutors", {
        params: {
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getTutorFormativi(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/TutorFormativi", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getAssociazioniTutorFormativoTirEstivi(idTutorForm: number, idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutorFormTirEstivi", {
        params: {
            idTutorForm: idTutorForm,
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssociazioniTutorFormativoAlternanza(idTutorForm: number, idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutorFormAlternanza", {
        params: {
            idTutorForm: idTutorForm,
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getClassiIstitutoAnno(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ClassiIstitutoAnnoScolastico", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getConvenzioneAttivita(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    } else if (activityType === 'tirocinioReIns') {
        idActivityType = 6
    }
    return axios.get(headUrl + "/ConvenzioneAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getConvenzioneDigitale(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    } else if (activityType === 'tirocinioReIns') {
        idActivityType = 6
    }
    return axios.get(headUrl + "/ConvenzioneDigitaleAttivita", {
        params: {
            idRichiesta: idRichiesta,
            idTipoAttivita: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getPercorsoFormativoDigitale(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    } else if (activityType === 'tirocinioReIns') {
        idActivityType = 6
    }
    return axios.get(headUrl + "/PercorsoFormativoDigitaleAttivita", {
        params: {
            idRichiesta: idRichiesta,
            idTipoAttivita: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getConvenzioneAttivitaFromId(idDoc: number) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    // if (activityType === 'tirocinioEstivo') {
    //     idActivityType = 1
    // } else if (activityType === 'alternanza') {
    //     idActivityType = 2
    // } else if (activityType === 'tirocinioFormativo') {
    //     idActivityType = 4
    // }
    return axios.get(headUrl + "/ConvenzioneAttivitaFromId", {
        params: {
            idDoc: idDoc
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getDocDigitaleById(idDocumento: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetDocDigitaleById", {
        params: {
            idDocumento: idDocumento
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getProgettoOrientamento(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    }
    return axios.get(headUrl + "/ProgettoOrientamentoAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirEstiviAllievo(idAllievo: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirEstiviAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteAlternanzaAllievo(idAllievo: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteAlternanzaAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviAssegnatiAziendaTirFormativo(idAnnoScolastico: number, idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiAziendaTirFormativo", {
        params: {
            idAnnoScolastico: idAnnoScolastico,
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirFormativi(idIscrizioneAttivita: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirFormativi", {
        params: {
            idIscrizioneAttivita: idIscrizioneAttivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getStudentsTutorTirFormativi(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/StudentsTutorTirFormativi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirFormativiIndirizzoStudio(idIndirizzoStudio: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirFormativiIndirizzoStudio", {
        params: {
            idIndirizzoStudio: idIndirizzoStudio,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getTirFormativiIstituto(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetTirFormativiIstituto", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(result => {
        return result.data
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText);
            throw error
        })
}

function getAllieviPreAssegnatiTirFormativi(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviPreAssegnatiTirFormativi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssociazioniTutorFormativoTirFormativi(idTutorForm: number, idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutorFormTirFormativi", {
        params: {
            idTutorForm: idTutorForm,
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssociazioniTutorAziendaleTirEstivo(idTutor: number, idAzienda: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutorAziendaleTirEstivi", {
        params: {
            idTutor: idTutor,
            idAzienda: idAzienda,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssociazioniTutorAziendaleAlternanza(idTutor: number, idAzienda: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutorAziendaleAlternanza", {
        params: {
            idTutor: idTutor,
            idAzienda: idAzienda,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getReportVisite(idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ReportVisite", {
        params: {
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getReportVisiteAdmin(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ReportVisite", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getConsensoAttivita(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    } else if (activityType === 'tirocinioReIns') {
        idActivityType = 6
    }
    return axios.get(headUrl + "/ConsensoAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getCurriculumVitae(idPdf: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/Curriculum", {
        params: {
            idPdf: idPdf
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getCurriculumAnni(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/CurriculumAnni", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getCurriculumArticolazioni(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/CurriculumArticolazioni", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getCurriculumClassi(idIstituto: number, idAnnoScolastico: number, idArticolazione: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/CurriculumClassi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idArticolazione: idArticolazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getCurriculumAllievi(idIstituto: number, idAnnoScolastico: number, idArticolazione: string, classe: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/CurriculumAllievi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idArticolazione: idArticolazione,
            classe: classe
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirFormativiAllievo(idAllievo: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirFormativiAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getDetailsAbbinamentoAllievoAzienda(idRichiesta: number, attivita: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetDetailsAbbinamentoAllievoAzienda", {
        params: {
            idRichiesta: idRichiesta,
            attivita: attivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getDetailsAbbinamentoTutorAllievo(idAllievo: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetDetailsAbbinamentoTutorAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssociazioniTutorAziendaleTirFormativo(idTutor: number, idAzienda: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutorAziendaleTirFormativi", {
        params: {
            idTutor: idTutor,
            idAzienda: idAzienda,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAttestatoFinaleInfo(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    }
    return axios.get(headUrl + "/AttestatoFinaleAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getDomandeQuestionario(idRichiesta: number, activityType: string, tipoQuestionario: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    var idTipoQuestionario: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'workshop') {
        idActivityType = 5
    }

    if (tipoQuestionario === 'questionarioTirocinante') {
        idTipoQuestionario = 1
    } else if (tipoQuestionario === 'questionarioAzienda') {
        idTipoQuestionario = 2
    } else if (tipoQuestionario === 'questionarioWorkshopAzienda') {
        idTipoQuestionario = 4
    } else if (tipoQuestionario === 'questionarioWorkshopAllievo') {
        idTipoQuestionario = 5
    }
    return axios.get(headUrl + "/GetDomandeQuestionario", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType,
            tipoQuestionario: idTipoQuestionario
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function checkQuestionario(idRichiesta: number, activityType: string, tipoQuestionario: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    var idTipoQuestionario: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'workshop') {
        idActivityType = 5
    }

    if (tipoQuestionario === 'questionarioTirocinante') {
        idTipoQuestionario = 1
    } else if (tipoQuestionario === 'questionarioAzienda') {
        idTipoQuestionario = 2
    } else if (tipoQuestionario === 'questionarioWorkshopAzienda') {
        idTipoQuestionario = 4
    } else if (tipoQuestionario === 'questionarioWorkshopAllievo') {
        idTipoQuestionario = 5
    }
    return axios.get(headUrl + "/CheckQuestionario", {
        params: {
            idRichiesta: idRichiesta,
            idActivityType: idActivityType,
            idTipoQuestionario: idTipoQuestionario
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRisposteQuestionario(idRichiesta: number, activityType: string, tipoQuestionario: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    var idTipoQuestionario: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'workshop') {
        idActivityType = 5
    }
    if (tipoQuestionario === 'questionarioTirocinante') {
        idTipoQuestionario = 1
    } else if (tipoQuestionario === 'questionarioAzienda') {
        idTipoQuestionario = 2
    } else if (tipoQuestionario === 'questionarioWorkshopAzienda') {
        idTipoQuestionario = 4
    } else if (tipoQuestionario === 'questionarioWorkshopAllievo') {
        idTipoQuestionario = 5
    }
    return axios.get(headUrl + "/GetRisposteQuestionario", {
        params: {
            idRichiesta: idRichiesta,
            idActivityType: idActivityType,
            idTipoQuestionario: idTipoQuestionario
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getListaAttivitaIstituto(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaAttivita", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getListaTipiAttivita() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaTipiAttivita", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getPercorsoFormativo(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    }
    return axios.get(headUrl + "/PercorsoFormativoAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getPattoFormativo(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    } else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    }
    return axios.get(headUrl + "/PattoFormativoAttivita", {
        params: {
            idRichiesta: idRichiesta,
            activityType: idActivityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAnniScolastici() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetAnniScolastici", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getStoricoSoggetto(idSoggetto: number, soggetto: string, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetStoricoSoggetto", {
        params: {
            idSoggetto: idSoggetto,
            soggetto: soggetto,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getLastYearSubscription(idAllievo: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetLastYearSubscription", {
        params: {
            idAllievo: idAllievo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteAttivita(idIscrizioneAllievo: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteAttivita", {
        params: {
            idIscrizioneAllievo: idIscrizioneAllievo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getStudentsTutorTirReIns(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/StudentsTutorTirReIns", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviPreAssegnatiTirReIns(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviPreAssegnatiTirReIns", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviAssegnatiAziendaTirReIns(idAnnoScolastico: number, idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiAziendaTirReIns", {
        params: {
            idAnnoScolastico: idAnnoScolastico,
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getRichiesteTirReInsAllievo(idAllievo: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetRichiesteTirReInsAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getPreferenzeWorkshopAzienda(idIscrizione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetPreferenzeWorkshopAzienda", {
        params: {
            idIscrizione: idIscrizione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getListaIscrizioniWorkshop(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaIscrizioniWorkshop", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getTipiContratto() {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaTipiContratto", {
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getListaProposteLavoroAzienda(idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaProposteLavoroAzienda", {
        params: {
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getListaProposteLavoroIstituto(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaProposteLavoroIstituto", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getListaProposteLavoroAllievo(idAllievo: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetListaProposteLavoroAllievo", {
        params: {
            idAllievo: idAllievo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getQuestionariWorkshopAziende(idIstituto: number, idAnnoScolastico: number, idTipoQuestionario: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetQuestionariWorkshopAziende", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTipoQuestionario: idTipoQuestionario
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getQuestionariWorkshopAllievi(idIstituto: number, idAnnoScolastico: number, idTipoQuestionario: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetQuestionariWorkshopAllievi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTipoQuestionario: idTipoQuestionario
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getTemplateDoc(idTemplate: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetTemplateDoc", {
        params: {
            idTemplate: idTemplate
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getCandidaturePropostaLavoro(idProposta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetCandidaturePropostaLavoro", {
        params: {
            idProposta: idProposta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getGiorniWorkshop(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetGiorniWorkshop", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}


function getTurniWorkshop(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetTurniWorkshop", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviAssegnatiTutor(idIstituto: number, idAnnoScolastico: number, idTutor: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviAssegnatiTutor", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idTutor: idTutor
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getClassiArticolazioneIstitutoAnno(idIstituto: number, idAnnoScolastico: number, idArticolazione: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ClassiArticolazioneIstituto", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idArticolazione: idArticolazione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getContattiAzienda(idAzienda: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ContattiAzienda", {
        params: {
            idAzienda: idAzienda,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getNoteAzienda(idAzienda: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/NoteAzienda", {
        params: {
            idAzienda: idAzienda,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getPreferenzeColloquioAzienda(idIscrizione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetPreferenzeColloquioAzienda", {
        params: {
            idIscrizione: idIscrizione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function checkPattoCorresponsabilitaAllievo(idAllievo: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/CheckPattoCorresponsabilitaAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAllieviIscrittiTipoAttivita(idIstituto: number, idAnnoScolastico: number, tipoAttivita: string) {
    //ritorna la lista degli studenti per un dato istituto
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AllieviIscrittiTipoAttivita", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            tipoAttivita: tipoAttivita
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssegnazioniAreeAziende(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AssegnazioniAreeAziende", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssegnazioniAreeAllievi(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AssegnazioniAreeAllievi", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAssegnazioniAllieviAttivitaSettore(idIstituto: number, idAnnoScolastico: number, idSettore: number, activityType: string) {
    //ritorna la lista degli studenti per un dato istituto
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/AssegnazioniAllieviAttivitaSettore", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico,
            idSettore: idSettore,
            activityType: activityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getGiorniColloquiAzienda(idAzienda: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GiorniColloquiAzienda", {
        params: {
            idAzienda: idAzienda,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getTurniColloquiCV(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/TurniColloquiCV", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getElencoFirme(idRichiesta: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ElencoFirme", {
        params: {
            idRichiesta: idRichiesta,
            activityType: activityType
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getIspezioneAzienda(idAzienda: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetIspezioneAzienda", {
        params: {
            idAzienda: idAzienda,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getIspezione(idIspezione: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetIspezione", {
        params: {
            idIspezione: idIspezione
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAttivitaFromIscrizioneAzienda(idIscrizioneAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetAttivitaFromIscrizioneAzienda", {
        params: {
            idIscrizioneAzienda: idIscrizioneAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getDocDVR(idRichiesta: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetDocDVR", {
        params: {
            idRichiesta: idRichiesta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function createAbbinamentoAlternanza(idAllievo: number, idIstitutoAnnoScolastico: number, idInformazioneAlternanza: number, idTutorFormativo: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/CreateAbbinamentoAlternanza", {
        params: {
            idAllievo: idAllievo,
            idIstitutoAnnoScolastico: idIstitutoAnnoScolastico,
            idInformazioneAlternanza: idInformazioneAlternanza,
            idTutorFormativo: idTutorFormativo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function downloadAttivitaReport(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/DatiReportAttivitaIstituto", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function downloadRendicontazionePCTOReport(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/DatiRendicontazionePCTOIstituto", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getApprendistati(idIstituto: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/Apprendistati", {
        params: {
            idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

// ***********Funzione di Test***********************
function getTest(id: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get("http://localhost:8181" + "/Test", {
        params: {
            id: id
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error
    })
}
